module.exports = __webpack_public_path__ + "static/media/banescoLogoB&WBG.f61a2437.svg";